//for header
$( document ).ready(function() {
  $('.mega-menu.bubble_mega_menu').mouseenter(function(){  
    $('details.mega-menu.bubble_mega_menu').removeAttr('open')
    $(this).attr('open',true)
  })
  $('.mega-menu.bubble_mega_menu').mouseleave(function(){
   const menu = $(this);
    setTimeout(function() {
        menu.removeAttr('open');
    }, 4000);
  });
  $('.bubble_gift_offer_tab img').click(function(){
    $('body, .gift_offer_opacity').addClass('offertab');
  });
  $('.gift_offer_value_close_btn').click(function(){
    $('body, .gift_offer_opacity').removeClass('offertab');
  });

  //wishlisht code
  document.dispatchEvent(new 
CustomEvent("swym:collections-loaded"));
  //end wishlishr code
  });
// for smooth scroll
document.addEventListener("DOMContentLoaded", () => {
    const target = document.getElementById(window.location.hash.substring(1));
    if (target) {
        target.scrollIntoView({ behavior: "smooth" });
    }
});

// cart-item-edit-btn
// document.addEventListener('DOMContentLoaded', function () {

//   const removeLinks = document.querySelectorAll('.cart_product_edit_btn');

//   removeLinks.forEach(link => {
//     link.addEventListener('click', function (event) {
//       event.preventDefault(); 

//       const cartItem = this.closest('.cart-item');
//       const productId = cartItem.dataset.id;

//       if (cartItem) {
//         cartItem.remove();
//         console.log(`Product with ID ${productId} removed from the cart.`);
//       } else {
//         console.error('Cart item not found.');
//       }

//     });
//   });
// });


